module.exports = __webpack_public_path__ + "/login_ui/img/jm-bd7d859f069e07c4857c7d9a3b29a149.svg";